import type { ISceneObj } from '../../../types/SceneType';

export type FlowEditorReadiness =
	| { phase: 'awaiting_scene' }
	| { phase: 'ready'; source: 'new' | 'saved_graph' | 'reconstructed' };

function hasFlowGraph(scene: ISceneObj | null | undefined): boolean {
	const graph = scene?._meta?.flowGraph;
	if (!graph?.nodes) return false;
	return Array.isArray(graph.nodes) ? graph.nodes.length > 0 : Object.keys(graph.nodes).length > 0;
}

/**
 * Scene semantics are sufficient to open the editor; flowGraph enriches layout
 * but is no longer a hard dependency now that complex nodes reconstruct natively.
 */
export function deriveFlowEditorReadiness(args: {
	flowId: string;
	storeScene?: ISceneObj;
	currentScene?: ISceneObj | null;
}): FlowEditorReadiness {
	if (!args.flowId || args.flowId === 'new') return { phase: 'ready', source: 'new' };
	if (!args.storeScene && !args.currentScene) return { phase: 'awaiting_scene' };
	if (hasFlowGraph(args.storeScene) || hasFlowGraph(args.currentScene)) {
		return { phase: 'ready', source: 'saved_graph' };
	}
	return { phase: 'ready', source: 'reconstructed' };
}
